export const STORAGE_KEYS = {
  NEXUS_HOST: 'nexusHost',
  NEXUS_SECRET: 'nexusSecret',
} as const